import { Icon, Table, TableContainer } from "@mui/material";
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { rankItem } from "@tanstack/match-sorter-utils";

import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import MDBox from "components/MDBox";
import { useEffect, useMemo, useState } from "react";
import { TableBody_, TableHead_ } from "./components/table";
import { SetPage } from "./components/pagination";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);
  addMeta({ itemRank });
  return itemRank.passed;
};

function CheckboxTable2({
  data: tableData,
  setData = null,
  columns: tableColumns,
  columnFilter = null,
  setColumnFilter = null,
  onSelectedRowsChange = null,
  customRowSelection = null,
  setCustomRowSelection = null,
  onFilterRowsChange = null,
  customColor=null,
  customFilter=null
}) {
  const [columnFilters, setColumnFilters] = useState([]);
  //const data = useMemo(() => tableData, [tableData]);
  const data = tableData;
  const columns = useMemo(() => tableColumns, [tableColumns]);
  const [rowSelection, setRowSelection] = useState({});
  console.log(rowSelection);
  const [sorting, setSorting] = useState([]);

  const table = useReactTable({
    data,
    columns,
    filterFns: { fuzzy: fuzzyFilter },
    getRowId:row=>row.id,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onColumnFiltersChange: columnFilter === null ? setColumnFilters : setColumnFilter,
    onRowSelectionChange: customRowSelection === null ? setRowSelection : setCustomRowSelection,
    onSortingChange: setSorting,
    state: {
      columnFilters: columnFilter === null ? columnFilters : columnFilter,
      rowSelection: customRowSelection === null ? rowSelection : customRowSelection,
      sorting,
    },
    meta: {
      updateData: (rowIndex, columnId, value) => {
        setData((prev) =>
          prev.map((row, index) =>
            index === rowIndex ? { ...prev[rowIndex], [columnId]: value } : row
          )
        );
      },
    },
  });
  useEffect(() => {
    if (onSelectedRowsChange !== null) {
      onSelectedRowsChange(table.getSelectedRowModel().flatRows.map((row) => row.original));
    }
  }, [rowSelection, customRowSelection, table, onSelectedRowsChange]);
  useEffect(() => {
    if (customRowSelection !== null) {
      console.log("custom select");
      setCustomRowSelection({});
    } else {
      setRowSelection({});
    }
  }, [data]);
  useEffect(() => {
    if (onFilterRowsChange !== null) {
      onFilterRowsChange(table.getFilteredRowModel().flatRows.map((row) => row.original));
    }
  }, [columnFilters, data]);
  const { pageIndex, pageSize } = table.getState().pagination;
  const { getPageCount, getCanPreviousPage, getCanNextPage, setPageIndex, setPageSize } = table;
  const showTotalEntries = true;
  const totalData = table.getPrePaginationRowModel()?.rows.length;
  const entriesStart = pageIndex === 0 ? pageIndex + 1 : pageIndex * pageSize + 1;
  let entriesEnd;
  if (pageIndex === 0) {
    entriesEnd = pageSize;
  } else if (pageIndex === getPageCount() - 1) {
    entriesEnd = totalData;
  } else {
    entriesEnd = pageSize * (pageIndex + 1);
  }
  const pageOptions = [...Array(getPageCount())].map((x, index) => index);
  const renderPagination = pageOptions.map((x) => (
    <MDPagination
      item
      key={x}
      active={pageIndex === x}
      onClick={() => {
        setPageIndex(x);
      }}
    >
      {x + 1}
    </MDPagination>
  ));
  const customizedPageOptions = pageOptions.map((x) => x + 1);
  const handleInputPagination = ({ target: { value } }) => {
    value > pageOptions.length || value < 0 ? setPageIndex(0) : setPageIndex(Number(value));
  };
  const handleInputPaginationValue = ({ target: { value } }) => {
    setPageIndex(Number(value));
  };

  const setPageProps = {
    pageSize,
    entriesStart,
    entriesEnd,
    totalData,
    onChange: (e, value) => setPageSize(value, 10),
  };
  const height = table.getRowModel().rows.length === 0 ? "0" : "545px"
  return (
    <>
      <TableContainer sx={{ borderRadius: ".25rem", border: "1px solid #c9c9c9",height:height,backgroundColor:"inherit" }}>
        <Table stickyHeader>
          <TableHead_ table={table} />
          <TableBody_ table={table} customColor={customColor} customFilter={customFilter} />
        </Table>
         
      </TableContainer>
      <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{background:"white"}}
          p={!showTotalEntries && pageOptions.length === 1 ? 0 : 1.5}
        >
          {showTotalEntries && <SetPage {...setPageProps} />}

          {pageOptions.length > 1 && (
            <MDPagination variant="gradient" color="info">
              {getCanPreviousPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex - 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                </MDPagination>
              )}
              {renderPagination.length > 6 ? (
                <MDBox width="5rem" mx={1}>
                  <MDInput
                    inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
                    value={customizedPageOptions[pageIndex]}
                    onChange={(handleInputPagination, handleInputPaginationValue)}
                  />
                </MDBox>
              ) : (
                renderPagination
              )}
              {getCanNextPage() && (
                <MDPagination item onClick={() => setPageIndex(pageIndex + 1)}>
                  <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                </MDPagination>
              )}
            </MDPagination>
          )}
        </MDBox>
    </>
  );
}

export default CheckboxTable2;
